module.exports = __webpack_public_path__ + "static/review1-min-89ed933e3056222778cda4fa13ab4aec.webp";